<template>
    <div>
        <el-row></el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        created: function () {
            let userId = this.getUrlKey("userId");
            let code = this.getUrlKey("code");
            if (userId || code) {
                if (userId) {
                    this.getCorpUserInfo(userId);
                }
            } else {
                window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getCorpidCode?state=7";
            }
        },
        methods:{
            getStoreByStructsByStaffId(storeid,staffid){
                this.$post("store/getStoreByStructsByStaffId",{storeid:storeid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        localStorage.setItem("storeid",res.object[0].brandid);
                        localStorage.setItem("parentstoreid",res.object[0].brandid);
                        this.$router.push("/hairgrid");
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCorpUserInfo(staffid){
                this.$post("wechat/getCorpUserInfo",{staffid:staffid}).then(res=>{
                    if(res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("querystaffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename",data.staff.storename);
                        localStorage.setItem("storeid",data.staff.storeid);
                        localStorage.setItem("parentstoreid",data.staff.storeid);
                        let posid=data.staff.posid;
                        if(posid=="ca5f888b2acc46b98d6d2f265ae5101a" || posid=="f1f91003a7464557af536065a06df68e" || posid=="4aebd0e8576b459c9f3eec52f1e21d1e"
                            || posid=="42d7c57fc37e4b2c83b89babb6d33487"){
                                this.$router.push("/hairstafftabbar");
                            }
                            else if(posid=="9d6032cc834748f5bc2932ff73bd9d57" || posid=="9132ffd069fd494687c1c9bc929baf5d" || posid=="07434c86082d482cb5e3a9a8a5b8dbe8"){
                                this.$router.push("/hairgrid");
                            }
                            else if("b7781c4e3f9249d9b3c5d2f1a183eae5"==posid){
                                this.getStoreByStructsByStaffId(data.staff.storeid,data.staff.staffid);
                            }
                        }
                    }
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/managerlogin.vue